import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  label: 'Home',
  href: '/#home',
  isRoute: false
}, {
  label: 'About',
  href: '/#about',
  isRoute: false
}, {
  label: 'Services',
  href: '/#services',
  isRoute: false
}, {
  label: 'Noir Atelier',
  href: '/noir-atelier',
  isRoute: true
}, {
  label: 'Contact',
  href: '/#contact',
  isRoute: false
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleNavClick = (link: (typeof navLinks)[0]) => {
    setMobileOpen(false);
    if (!link.isRoute && location.pathname !== '/') {
      // If we're on a sub-page and clicking a hash link, navigate to home first
      window.location.href = link.href;
    }
  };
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'bg-dark-900/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`} data-id="element-94">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-95">
        <div className="flex items-center justify-between h-20" data-id="element-96">
          <Link to="/" className="flex items-center gap-3" data-id="element-97">
            <span className="text-gold font-display text-xl font-bold tracking-widest" data-id="element-98">
              VANSCAPE
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8" data-id="element-99">
            {navLinks.map(link => link.isRoute ? <Link key={link.label} to={link.href} className={`text-sm font-medium hover:text-gold transition-colors duration-300 tracking-wide uppercase ${location.pathname === link.href ? 'text-gold' : 'text-white/70'}`} data-id="element-100">
                  {link.label}
                </Link> : <a key={link.label} href={link.href} onClick={() => handleNavClick(link)} className="text-sm font-medium text-white/70 hover:text-gold transition-colors duration-300 tracking-wide uppercase" data-id="element-101">
                  {link.label}
                </a>)}
          </div>

          <div className="hidden md:block" data-id="element-102">
            <a href="/#contact" className="inline-block px-6 py-2.5 bg-gold text-dark-900 text-sm font-semibold tracking-wide uppercase rounded hover:bg-gold-hover transition-colors duration-300" data-id="element-103">
              Get a Quote
            </a>
          </div>

          <button className="md:hidden text-white/80 hover:text-gold transition-colors" onClick={() => setMobileOpen(!mobileOpen)} aria-label="Toggle menu" data-id="element-104">
            {mobileOpen ? <XIcon size={24} data-id="element-105" /> : <MenuIcon size={24} data-id="element-106" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-107">
        {mobileOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-dark-900/98 backdrop-blur-md border-t border-white/5" data-id="element-108">
            <div className="px-6 py-6 space-y-4" data-id="element-109">
              {navLinks.map(link => link.isRoute ? <Link key={link.label} to={link.href} onClick={() => setMobileOpen(false)} className="block text-sm font-medium text-white/70 hover:text-gold transition-colors tracking-wide uppercase" data-id="element-110">
                    {link.label}
                  </Link> : <a key={link.label} href={link.href} onClick={() => handleNavClick(link)} className="block text-sm font-medium text-white/70 hover:text-gold transition-colors tracking-wide uppercase" data-id="element-111">
                    {link.label}
                  </a>)}
              <a href="/#contact" onClick={() => setMobileOpen(false)} className="inline-block mt-4 px-6 py-2.5 bg-gold text-dark-900 text-sm font-semibold tracking-wide uppercase rounded" data-id="element-112">
                Get a Quote
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}